class ConfirmationType {
	static General = 0;
	static Sync = 1;
	static Syndicated = 2;
	static SpotBlock = 3;
	static ExtendDuration = 4;
	static TransferHost = 5;
	static ETM = 6;
}

export default ConfirmationType;